import classNames from 'classnames';

export function Card({ children, className }) {
  return (
    <div className={classNames('flex flex-col bg-white p-5 sm:p-8 md:p-10 rounded-lg shadow-md', className)}>
      {children}
    </div>
  );
}

export function CheckResultCard({ children, className }) {
  return <div className={classNames('flex bg-white p-5 rounded shadow-md', className)}>{children}</div>;
}
